export default __webpack_public_path__ + "static/media/mm-edge-week-17.b9a65acc.jpg";